// The reducer is a pure function that takes the previous state and an action,
// and returns the next state.

// For now, just remember that the reducer must be pure.
// Given the same arguments, it should calculate the next state and return it.
// No surprises. No side effects. No API calls. No mutations. Just a calculation


// { ...state, ...newState }
// https://stackoverflow.com/questions/46761718/update-nested-object-using-object-assign

const designs = (
	state = {
		designsCount: 0,
		importedSets: [],
		designLibrary: false,
	}, action ) => {
	switch ( action.type ) {
		case 'DESIGNS_COUNT_SET':
			return {
				...state,
				designsCount: action.count,
			};

		case 'DESIGN_LIBRARY_SET':
			return {
				...state,
				designLibrary: action.designs,
			};


		case 'IMPORTED_SETS_ADD':
			if ( state.importedSets.indexOf( action.set ) === -1 ) {
				return {
					...state,
					importedSets: [...state.importedSets, action.set]
				};
			}
			// Don't add duplicates
			return {
				...state,
				importedSets: state.importedSets,
			};

		case 'IMPORTED_SETS_EMPTY':
			return {
				...state,
				importedSets: [],
			};

		default:
			return state;
	}
};

export default designs;



// WEBPACK FOOTER //
// ./src/reducers/designs.js